const Process5Icon = ({ length = 5, type = "green" }) => {
  const colors = ["#9AA9B3", "#9AA9B3", "#9AA9B3", "#9AA9B3", "#9AA9B3"];
  for (let i = 0; i < length; i++) {
    colors[i] = type === "green" ? "#00BE3C" : "#FF4141";
  }
  return (
    <svg
      width="69"
      height="5"
      viewBox="0 0 69 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="12" height="5" rx="2.5" fill={colors[0]} />
      <rect x="14.5" width="12" height="5" rx="2.5" fill={colors[1]} />
      <rect x="28.5" width="12" height="5" rx="2.5" fill={colors[2]} />
      <rect x="42.5" width="12" height="5" rx="2.5" fill={colors[3]} />
      <rect x="56.5" width="12" height="5" rx="2.5" fill={colors[4]} />
    </svg>
  );
};
export default Process5Icon;
